import { formatMoney } from "infra/helpers/number";
import moment from "moment";
import { Flex } from "@chakra-ui/layout";
import { RelatorioDespesaItem } from "features/relatorios/typings";
import { useMemo } from "react";
import DocumentosList from "./../components/DocumentosList";
import { getContaCategoriaText } from "./../util/getContaCategoriaText";

function useDespesasColumns() {
  return useMemo(() => {
    return [
      {
        title: "Vencimento",
        render: (original: RelatorioDespesaItem) =>
          moment(original.dataVencimento).format("DD/MM/YYYY"),
      },
      {
        title: "Pagamento",
        render: (original: RelatorioDespesaItem) =>
          original.dataPagamento
            ? moment(original.dataPagamento).format("DD/MM/YYYY")
            : "--",
      },
      {
        title: "Favorecido",
        render: (original: RelatorioDespesaItem) => original.pessoa.nome,
      },
      {
        title: "Descrição",
        dataIndex: "descricao",
      },
      {
        title: "Documento",
        width: "150px",
        render: (original: RelatorioDespesaItem) => (
          <DocumentosList
            items={original.anexos}
            collapsable={original.anexos.length > 2}
          />
        ),
      },
      {
        title: "Conta Categoria",
        width: "200px",
        render: (original: RelatorioDespesaItem) =>
          getContaCategoriaText(original.contasCategorias),
      },
      {
        title: "Valor",
        align: "right" as any,
        render: (original: RelatorioDespesaItem) => (
          <Flex fontWeight="bold" justifyContent="flex-end">
            {original.valorPago
              ? formatMoney(original.valorPago)
              : formatMoney(original.valor)}
          </Flex>
        ),
      },
    ];
  }, []);
}

export default useDespesasColumns;
